import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button";
import gFileUpload from "@/components/g-file-upload/g-file-upload";
import { CepService } from "@/shared/services/CEP";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import ClienteDesenvolvimentoController from "@/shared/controllers/cliente/clienteDesenvolvimentoController";
import CidadeController from "@/shared/controllers/cidade/cidadeController";
import EstadoController from "@/shared/controllers/estado/estadoController";
import Tools from "@/shared/services/tools";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events";
import {mask} from 'vue-the-mask'
import RepresentanteController from "@/shared/controllers/representante/representanteController";

export default defineComponent( {
  name: "Clientes - Ficha Cadastral",
  directives: {mask},
  components: {
    gCard,
    gForm,
    gButton,
    gFileUpload,
  },

  props: {},
  mounted() {
    if (this.$route.params.id !== null) {
      this.clienteId = this.$route.params.id

    }

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.preencheEmpresa();
      this.RepresentanteId =   this.$store.state.representanteSelecionadoId || this.$store.state.cliente.representanteId;
    })

    this.preencheEmpresa();

    if(this.$store.state.representanteSelecionadoId == null)
     {
      RepresentanteController.getRepresentanteByNome(this.$store.state.representanteSelecionadoNome).requisicao.then((r)=>{
        if(r.data.data[0].id){
          this.RepresentanteId = r.data.data[0].id
        }
      })
     }
     else{
       this.RepresentanteId =   this.$store.state.representanteSelecionadoId || this.$store.state.cliente.representanteId;
     }
    this.popularDropDownEstado()
    this.SegmentoArray = ClienteController.getClienteTipo().Segmentos;
    this.popularDropDownEmpresa()
    this.popularDropDownPerfilMaterial()
    this.popularDropDownPotencial()
    this.popularDropDownTipoContato()
    this.popularDropDownEmpresaAgrupador()


    // alterado para aceitar clienteSituação 0 e 1
    if (this.$store.state.cliente != null && [0,1].includes(this.$store.state.cliente.clienteSituacao) ) {
      this.modoEdicao = true
      this.popupFichaCadastralCliente = false
      this.nomeFantasia = this.$store.state.cliente.nomeFantasia
      this.cnpj = this.$store.state.cliente.cnpj
      this.razaoSocial = this.$store.state.cliente.razaoSocial
      this.EmailNFE = this.$store.state.cliente.emailNFE
      this.codigo = this.$store.state.cliente.curvaCliente
      this.CheckPIS = this.$store.state.cliente.pisCofins
      this.CheckIncentivoFiscal = this.$store.state.cliente.icms
      this.CheckIPI = this.$store.state.cliente.ipi

			ClienteController.GetTelefoneClienteById(this.$store.state.cliente.id).requisicao.then((r)=>{
        if(r.data.message){
          this.telefonecelular = r.data.message
        }
      })

      if(this.$store.state.cliente.possuiEmpresaEdicao){
        this.EmpresaSelecionada = this.$store.state.cliente.empresaId
      }

      this.endereco = (this.$store.state.cliente.enderecos).map(item => { return item.nome })[0]
      this.cep = (this.$store.state.cliente.enderecos).map(item => { return item.cep })[0]
      this.bairro = (this.$store.state.cliente.enderecos).map(item => { return item.bairro })[0]
      this.complemento = (this.$store.state.cliente.enderecos).map(item => { return item.complemento })[0]
      this.EstadoSelecionado = this.$store.state.cliente.estadoId
      this.CidadeSelecionada = this.$store.state.cliente.cidadeId
      this.CheckOrdemCompra = this.$store.state.cliente.exigeOrdemCompraNaNF
      this.CheckCodEspecifico = this.$store.state.cliente.exigeCodigoCompraNaNF
      this.DescricaoObservacao = this.$store.state.cliente.descricaoObservacao
      this.inscricaoEstadual = this.$store.state.cliente.inscricaoEstadual
      this.numeroSuframa = this.$store.state.cliente.numeroSuframa
      this.SegmentoSelecionado = this.$store.state.cliente.clienteTipoId
      this.ClienteSituacao = this.$store.state.cliente.clienteSituacaoSwitch
      this.potencialCliente = this.$store.state.cliente.potencialCliente
      this.PotencialSelecionado = this.$store.state.cliente.potencialCliente
      this.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
      this.suframaSimNao = this.$store.state.cliente.zonaFranca;
      this.numeroSuframa = this.$store.state.cliente.numeroSuframa;

      this.checkboxExt = this.$store.state.cliente.clienteExterior

      /*eslint-disable*/
      
      if(this.$store.state.cliente.clienteAgrupador != null){
          this.EmpresaAgrupador = this.$store.state.cliente.clienteAgrupador.empresaAgrupadorId
          this.nomeClienteAgrupador = this.$store.state.cliente.clienteAgrupador.razaoSocial

        }

      this.buscarClientes(this.nomeClienteAgrupador)

      this.$store.state.cliente.contatos.forEach((Element) => {
        console.info(Element)
        let variavel =
        {
          "Sequencia": Element.sequencia,
          "CelularExterior": Element.CelularExterior,
          "ClienteSite": Element.clienteSite,
          "CodigoEspecifico": Element.codigoEspecifico,
          "CodigoEspecificoValue": Element.codigoEspecifico ? 'SIM' : 'NÃO',
          "Email": Element.email.trim(),
          "NomeContato": Element.nomeContato,
          "NomeFuncao": Element.nomeFuncao,
          "NumeroCelular": Element.numeroCelular,
          "NumeroTelefone": Element.numeroTelefone,
          "OrdemCompra": Element.ordemCompra,
          "OrdemCompraValue": Element.ordemCompra ? 'SIM' : 'NÃO',
          "TelefoneExterior": Element.TelefoneExterior,
          "TipoContato": "Comercial",
          "TipoContatoValue": parseInt(Element.tipoContato),
        }
        this.proximaSequencia = Element.sequencia + 1

        this.informacaocontato.push(variavel)
      })

      this.popularDropDownTipoContato()

    }
  },

  updated() { },

  setup(){
    return{
      v$: useVuelidate()
    }
  },
  validations(){
    return{
      cnpj: {require: helpers.withMessage("O campo de CNPJ é obrigatório", required)},
      razaoSocial: {require: helpers.withMessage("O campo de Razão Social é obrigatório", required)},
      nomeFantasia: {require: helpers.withMessage("O campo de Nome Fantasia obrigatório", required)},
      // EmpresaAgrupador: {require: helpers.withMessage("O campo de Empresa Agrupador é obrigatório", required)},
      // nomeClienteAgrupador: {require: helpers.withMessage("O campo de Cliente Agrupador é obrigatório", required )},
      // EmailNFE: {require: helpers.withMessage("O campo de E-mail NFE obrigatório", required)},
      endereco: {require: helpers.withMessage("O campo de Endereço é obrigatório", required)},
      telefonecelular: {require: helpers.withMessage("O campo de Telefone/Celular é obrigatório", required)},
      bairro: {require: helpers.withMessage("O campo de Bairro é obrigatório", required)},
      cep: {require: helpers.withMessage("O campo de CEP é obrigatório", required)},
      inscricaoEstadual: {require: helpers.withMessage("O campo de Inscrição Estadual é obrigatório", required)},


      EmpresaSelecionada: {require: helpers.withMessage("É necessário selecionar uma empresa", required)},
      SegmentoSelecionado: {require: helpers.withMessage("É necessário selecionar um componente", required)},
      PerfilMaterialSelecionado: {require: helpers.withMessage("É necessário selecionar um Perfil de Material", required)},
      PotencialSelecionado: {require: helpers.withMessage("É necessário selecionar um Potencial", required)},
    }
  },
  data() {
    return {
      flagFicha: true,
      arquivosIds: [],
      sequencia: 1,
      proximaSequencia: 1,
      exibeSuframa: false,
      mensagemDeAviso: '',
      modoEdicao: false,
      exibeMensagemAviso: false,
      OrdemCompraCliente: false,
      CodigoEspecificoCliente: false,
      codigoExternoClienteAgrupador: '',
      razaoSocialClienteAgrupador: '',
      submit: false,
      listaAdicionados: [],
      pt1: true,
      cnpj: '',
      checkboxExt: false,
      ieIsento: false,
      exteriorIeIsento: false,
      codigo: null,
      razaoSocial: null,
      nomeFantasia: null,
      disabled: true,
      RepresentanteId: '',

      SegmentoArray: [],
      SegmentoSelecionado: null,

      EmpresaSelecionada: null,
      EmpresaArray: [],

      PerfilMaterialSelecionado: null,
      PerfilMaterialArray: [],

      PotencialSelecionado: null,
      PotencialArray: [],

      estado: null,
      cidade: null,

      CidadeSelecionada: {},
      CidadeArray: [],


      EstadoSelecionado: null,
      EstadoArray: [],


      //CEP
      cepValue: null,
      ufValue: null,
      cidadeValue: null,
      DesativaEstado: false,
      DesativaCidade: false,
      desabilitarcep: false,

      //teste para ver se realmente vai conseguir pegar o id e passar para a cidade para fazer a busca no backend
      EstadoSelecionadoCidade: [],

      TipoContato: null,
      TipoContatoArray: [],
      Colunas: [
        { field: 'Sequencia', header: 'Sequência' },
        { field: 'NomeContato', header: 'Nome Contato' },
        { field: 'NomeFuncao', header: 'Função' },
        { field: 'TipoContato', header: 'Tipo de Contato' },
        { field: 'ClienteSite', header: 'Site' },
        { field: 'NumeroTelefone', header: 'Telefone' },
        { field: 'NumeroCelular', header: 'Celular' },
        { field: 'Email', header: 'Email' },
        { field: 'OrdemCompraValue', header: 'Ordem de Compra' },
        { field: 'CodigoEspecificoValue', header: 'Código Especifico' },
        { field: 'TelefoneExterior', header: 'Telefone Exterior' },
        { field: 'CelularExterior', header: 'Celular Exterior' }

      ],

      Filtro: {
        'global': { value: null, matchMode: this.filtros.CONTAINS }, //permite buscar por colunas específicas
        'solicitacao': { value: null, matchMode: this.filtros.CONTAINS },
        'tipo': { value: null, matchMode: this.filtros.CONTAINS },
      },

      endereco: null,
      telefonecelular: '',
      cep: '',
      bairro: '',
      complemento: '',
      cv: '',
      suframaSimNao: null,
      inscricaoSuframa: '',
      inputs: [],
      potencialInventivo: [],
      inscricaoEstadual: '',
      nome: '',
      funcao: '',
      site: '',
      email: '',
      EmailNFE: null,
      telefone: [],
      telefoneExterior: [],
      celular: '',
      quantidade: '',
      OrdemCompra: false,
      CodigoEspecifico: false,
      observacoes: '',
      campoSuframa: true,
      campoExtra: true,
      campoDocumento: false,
      popupFichaCadastral: true,
      popupFichaCadastralCliente: false,
      popupICMS: false,
      popupPIS: false,
      popupIPI: false,
      testa: true,
      fileArray: [],
      popupcontatos: false,
      linhaSelecionada: {},
      desabilitarInscricaoEstadual: false,

      // POPUPCONTATO
      informacaocontato: [],
      contatosLista: [],
      NumeroCelular: null,
      NumeroTelefone: null,
      NomeContato: null,
      NomeFuncao: null,
      ClienteSite: null,
      Email: null,
      exigenciaPopup: null,
      clienteId: null,
      ICMSArray: [],
      PISArray: [],
      IPIArray: [],
      numeroSuframa: null,
      NumeroTelefoneExterior: null,
      NumeroCelularExterior: null,
      TelefoneExterior: null,
      CelularExterior: null,
      Id: '',
      AllCity: [],
      editando: false,
      CheckIncentivoFiscal: false,
      CheckPIS: false,
      CheckIPI: false,
      codClienteAgrupador: '',
      nomeClienteAgrupador: null,
      ClientesArray: [],
      informacaoClienteAgrupador: [],
      popupClienteAgrupador: false,
      ColunasClienteAgrupador: [
        { field: 'codigoExterno', header: 'Codigo' },
        { field: 'nomeFantasia', header: 'Nome' },

      ],
      styleImg: 'width: 350px; height: 350px; border: 1px solid #ccc; padding: 30px',
      popupjaexiste: false,
      CheckOrdemCompra: false,
      CheckCodEspecifico: false,
      DescricaoObservacao: '',
      desabilitado: false,
      alteracaoLista: false,
      cidadenome: null,
      alteracaoListaClienteAgrupador: false,
      situacaoVindaDoBanco: null,
      tempId: 0,
      escritobotao: true,
      largura: "240px",
      EdicaoBack: false,
      clienteIdEdicao: null,
      timer:null,
      ClienteSituacao: null,
      desabilitarCep: false,
      desabilitarEmailNFE: false,
      EmpresaAgrupadorArray: [],
      EmpresaAgrupador: null,
      imageArray: [],
      popupEditImage: false,
      desabilitaGravar: false
    }
  },
  methods: {
    camponumero($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault();
      }
    },
    buscarCep(){
        this.getCEP()
    },
    preencheEmpresa(){

      if(this.$store.state.cliente != null && this.$store.state.cliente.possuiEmpresaEdicao && this.$store.state.cliente.clienteSituacao == 0){
        this.EmpresaSelecionada = this.$store.state.cliente.empresaId
        return

      }
      this.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;

    },
    ImageEdit(){
      this.$isLoading(true)
      let tipo = ''

      if(this.popupICMS == true){
        tipo = 'ICMS'
      }

      else if(this.popupIPI == true){
        tipo = 'IPI'
      }

      else if(this.popupPIS == true){
       tipo = 'PIS'
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Arquivo/getArquivo`,
        data: {
          tipo : tipo,
          Arquivos: this.arquivosIds,
          ClienteId: this.clienteId,
        }
      })
      .then((response) => {
        this.imageArray = response.data.data
        this.AbrirPopupImage()
      })
      .catch(() => {
      });

    },

    deleteImage(id) {
      let arquivoid = id;
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Arquivo/deleteArquivo/${arquivoid}`,
      })
      .then(() => {
        this.$isLoading(false)
        this.ImageEdit()
      })
      .catch(() => {
      });
    },

    AbrirPopupImage(){
      this.popupEditImage = true
      this.$isLoading(false)
    },

    buscarClientesJaExiste(){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsById(this.$store.state.representanteSelecionadoId, this.EmpresaAgrupador, this.$store.state.cliente.clienteAgrupador.clienteAgrupadorId).requisicao
        .then(res => {
        
          this.ClientesArray = res.data.data
          this.nomeClienteAgrupador = res.data.data[0]

          this.setCodigoExternoEmpresa()
        })
      }, 1000);
    },

    setCodigoExternoEmpresa(){
      if(!this.nomeClienteAgrupador) return;
      this.codigoExternoClienteAgrupador = this.nomeClienteAgrupador.codigoExterno;
      this.razaoSocialClienteAgrupador = this.nomeClienteAgrupador.razaoSocial;
    },

    verificanomecidade() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cidade/GetNomeCidade',
        data: {
          Id: this.CidadeSelecionada
        }
      })
        .then((response) => {
          this.cidadenome = response.data.data.nomeCidade
          this.buscarEstado()
        })
        .catch(() => {
        });
    },
    verificaCPNJ() {
      if(this.cnpj.length == 18) {
        var cnpjValido = Tools.validaCNPJ(this.cnpj)
        if (! cnpjValido) {
          this.$toast.add({ severity: 'error', summary: 'CNPJ invalido', life: 5000 });
        }
        else {
          if(this.$store.state.representanteSelecionadoNome == "ADMINISTRADOR"){
            this.$toast.add({ severity: 'error', summary: 'ATENÇÃO!', detail: 'Não é permitido cadastrar clientes com o representante ADMINISTRADOR', life: 4000 });

          }
          else{
            this.conferecnpjApi()
          }
        }
      }
    },

    conferecnpjAPIExiste(){
      let buscaCNPJ = ({
        cnpj: (this.cnpj.replace(/[\D]/gm, '')),
        checkboxExt: this.checkboxExt,
        flagFicha: this.flagFicha,
        RepresentanteId: this.RepresentanteId,
        UnidadeId: this.EmpresaSelecionada,
        EmpresaId: this.EmpresaSelecionada,
        sintegra: false
      });
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
        data: buscaCNPJ
      })
        .then((response) => {
          let situacao = response.data.codigoGenerico;

          if(situacao === 0 || situacao === 3 || situacao === 4){
            if(situacao === 0)
            this.mensagemDeAviso = 'Já existe cliente cadastrado com o CNPJ informado!';

            if(situacao === 3)
            this.mensagemDeAviso = 'Já existe outro cliente cadastrado com o mesmo CNPJ para outro representante!';

            if(situacao === 4)
            this.mensagemDeAviso =  'Já existe outro cliente cadastrado com a mesma base do CNPJ para outro representante!';

            this.exibeMensagemAviso = true;
            return;
          }
          let dadosCliente = response.data.data;

          if(response.data.code !== -500){
            this.$store.state.cliente = dadosCliente


          }

          this.$store.commit('salvando');
          this.situacaoVindaDoBanco = dadosCliente.clienteSituacaoSwitch

        })
    },
    conferecnpjApi() {
      let buscaCNPJ = ({
        cnpj: (this.cnpj.replace(/[\D]/gm, '')),
        checkboxExt: this.checkboxExt,
        flagFicha: this.flagFicha,
        RepresentanteId: this.RepresentanteId,
        UnidadeId: this.EmpresaSelecionada,
        EmpresaId: this.EmpresaSelecionada,
        sintegra: true
      });
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
        data: buscaCNPJ
      })
        .then((response) => {
          let situacao = response.data.codigoGenerico;

          if((situacao === 0 || situacao === 3) && !this.modoEdicao){
            this.mensagemDeAviso = situacao === 0 ? 'Já existe cliente cadastrado com o CNPJ informado!' : 'Já existe outro cliente cadastrado com a mesma base do CNPJ para outro representante!';
            this.exibeMensagemAviso = true;
            return;
          }

          let dadosCliente = response.data.data;

          if(situacao === 2){
            this.modoEdicao = true;
            if (dadosCliente.clienteSituacaoSwitch === 1 || dadosCliente.clienteSituacaoSwitch == 0) {
              this.desabilitarInscricaoEstadual = false
            } else {
              this.desabilitarInscricaoEstadual = true
            }

            if (dadosCliente.cep === null) {
              this.desabilitarcep = false
            } else {
              this.desabilitarcep = true
            }

            // if (dadosCliente.emailNFE === null) {
            //   this.desabilitarEmailNFE = false
            // } else {
            //   this.desabilitarEmailNFE = true
            // }
          }

          if(response.data.code !== -500){
            this.$store.state.cliente = dadosCliente
            this.$store.state.cliente.clienteSituacao = 0

            if(dadosCliente !== null){

              if (dadosCliente.clienteSituacaoSwitch === 0 || dadosCliente.clienteSituacaoSwitch === null) {
                if(dadosCliente.enderecoPadrao)
                {

                  if(dadosCliente.enderecoPadrao.endereco)
                    {
                      this.endereco = dadosCliente.enderecoPadrao.endereco.substr(0,40);
                    }
                  this.EstadoSelecionado = dadosCliente.enderecoPadrao.estadoId;
                  this.CidadeSelecionada = dadosCliente.enderecoPadrao.cidadeId;
                  this.cep = dadosCliente.enderecoPadrao.cep ?? null;
                  if(dadosCliente.enderecoPadrao.complemento)
                    {
                      this.complemento = dadosCliente.enderecoPadrao.complemento.substr(0,25) ?? null;
                    }
                  if(dadosCliente.enderecoPadrao.bairro){
                    this.bairro = dadosCliente.enderecoPadrao.bairro.substr(0,25) ?? null;
                  }


                }
                let data = {
                  nomeCidade: dadosCliente.nomeCidade,
                  siglaEstado: dadosCliente.siglaEstado,
                }

                this.AddCidadeFicha(data)
              }

              if (dadosCliente.clienteSituacaoSwitch === 1) {
                this.cep = dadosCliente.cep;
              }

              this.ieIsento = dadosCliente.ieIsento;
              this.inscricaoEstadual = this.ieIsento ? 'ISENTO' : dadosCliente.inscricaoEstadual
              //this.PerfilMaterialSelecionado = dadosCliente.perfilMaterial;
              //this.PotencialSelecionado = dadosCliente.potencialCliente;
              //this.SegmentoSelecionado = dadosCliente.clienteTipoId;
              this.EmailNFE = dadosCliente.emailNFE;
              this.razaoSocial = dadosCliente.razaoSocial.substr(0,50);
              if(dadosCliente.nomeFantasia){
                this.nomeFantasia = dadosCliente.nomeFantasia.substr(0,20);
              }
              this.codigo = dadosCliente.codigo;
              this.DescricaoObservacao = dadosCliente.descricaoObservacao;
              this.telefonecelular = dadosCliente.telefoneCelular

              this.CheckIncentivoFiscal = dadosCliente.icms;
              this.CheckIPI = dadosCliente.ipi;
              this.CheckPIS = dadosCliente.pisCofins;

              this.OrdemCompraCliente = dadosCliente.exigeOrdemCompraNaNF;
              this.CodigoEspecificoCliente = dadosCliente.exigeCodigoCompraNaNF;

              this.suframaSimNao = dadosCliente.zonaFranca;
              this.numeroSuframa = dadosCliente.numeroSuframa;

              if(dadosCliente.clienteAgrupador){
                this.ClientesArray.push(dadosCliente.clienteAgrupador);
                this.nomeClienteAgrupador = dadosCliente.clienteAgrupador;
                this.setCodigoExternoEmpresa();
              }

              dadosCliente.contatos?.forEach(e => this.adicionaClienteContatoGrid(e))
            }
          } else {
            this.$toast.add({ severity: 'info', summary: 'CNPJ não encontrado na base', detail: response.data.message, life: 5000 });
          }

          this.$store.commit('salvando');
          this.situacaoVindaDoBanco = dadosCliente.clienteSituacaoSwitch

        })

    },

    editarCnpjExistente() {
      this.disabled = false
      if (this.situacaoVindaDoBanco == 0) {
        this.$router.push('/ficha-cadastro')
        this.bairro = (this.$store.state.cliente.enderecos).map(item => { return item.bairro })[0]
        this.cep = (this.$store.state.cliente.enderecos).map(item => { return item.cep })[0]
        this.CodigoEspecificoCliente = this.$store.state.cliente.exigeCodigoCompraNaNF
        this.OrdemCompraCliente = this.$store.state.cliente.exigeOrdemCompraNaNF
        this.CheckIncentivoFiscal = this.$store.state.cliente.icms
        this.CheckIPI = this.$store.state.cliente.ipi
        this.CheckPIS = this.$store.state.cliente.pisCofins
        this.CidadeSelecionada = this.$store.state.cliente.cidadeId
        this.clienteId = this.$store.state.cliente.id
        this.cnpj = this.$store.state.cliente.cnpj
        this.codigo = this.$store.state.cliente.codigo
        this.complemento = (this.$store.state.cliente.enderecos).map(item => { return item.complemento })[0]
        this.DescricaoObservacao = this.$store.state.cliente.descricaoObservacao
        this.endereco = (this.$store.state.cliente.enderecos).map(item => { return item.nome })[0]
        this.EstadoSelecionado = this.$store.state.cliente.estadoId
        this.informacaoClienteAgrupador = []
        this.informacaocontato = []
        this.inscricaoEstadual = this.$store.state.cliente.inscricaoEstadual
        this.nomeFantasia = this.$store.state.cliente.nomeFantasia
        this.numeroSuframa = this.$store.state.cliente.numeroSuframa
        this.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
        this.popupjaexiste = false
        this.PotencialSelecionado = this.PotencialArray.this.$store.state.cliente.potencialCliente
        this.razaoSocial = this.$store.state.cliente.razaoSocial
        this.SegmentoSelecionado = this.$store.state.cliente.clienteTipoId

        this.$store.state.cliente.contatos.forEach((Element) => {
          this.adicionaClienteContatoGrid(Element)
        })


      }
      else {
        // this.$router.push('/cliente-em-desenvolvimento')
      }
    },

    cancelarcadastrarcnpj() {
      this.popupjaexiste = false,
        this.cnpj = null,
        this.checkboxExt = false
    },
    adicionaClienteContatoGrid(clienteContatoViewModel){
      const contatoConvertido = {
        CelularExterior: clienteContatoViewModel.celularExterior,
        ClienteSite: clienteContatoViewModel.clienteSite,
        CodigoEspecifico: clienteContatoViewModel.codigoEspecifico,
        CodigoEspecificoValue: clienteContatoViewModel.codigoEspecifico ? 'SIM' : 'NÃO',
        Email: clienteContatoViewModel.email,
        Id: clienteContatoViewModel.id,
        NomeContato: clienteContatoViewModel.nomeContato,
        NomeFuncao: clienteContatoViewModel.nomeFuncao,
        NumeroCelular: clienteContatoViewModel.numeroCelular,
        NumeroTelefone: clienteContatoViewModel.numeroTelefone,
        OrdemCompra: clienteContatoViewModel.ordemCompra,
        OrdemCompraValue: clienteContatoViewModel.ordemCompra ? 'SIM' : 'NÃO',
        TelefoneExterior: clienteContatoViewModel.TelefoneExterior,
        TipoContato: clienteContatoViewModel.tipoContatoText,
        TipoContatoValue: clienteContatoViewModel.tipoContato,
        Sequencia: clienteContatoViewModel.sequencia,
      }
      this.informacaocontato.push(contatoConvertido)
    },
    setCidade() {
      let cidade = this.CidadeArray.find((Element) => Element.id == this.CidadeSelecionada)
      let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)

      if (estado)
        this.EstadoSelecionado = estado.id

      this.cidadenome = cidade.nomeCidade

      this.exibeSuframa = cidade.nomeCidade.toLowerCase() === 'manaus'


    },
    AdicionarNaTabela() {
      if (this.Email != "") {
        // eslint-disable-next-line
        let validacaoEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!this.Email.match(validacaoEmail)) {
          this.$toast.add({ severity: 'error', summary: 'Email Inválido', detail: 'Adicione um email válido', life: 4000 });
          return;
        }
      }

      if (this.NomeContato == '') {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Nome do contato é obrigatório', life: 4000 });
        return
      }

      if (!this.NumeroTelefone || !this.NumeroCelular || !this.Email ) {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'É Obrigatório ter um Telefone,um celular e email', life: 4000 });
        return
      }

       /* eslint-disable */

      if(!this.TipoContato)
        {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'É Obrigatório ter um Tipo de contato', life: 4000 });
        return
        }

        if(this.TipoContato.text == '')
          {

            this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'É Obrigatório ter um Tipo de contato', life: 4000});
            return
          }

      var OrdemCompraValueSN
      if (this.OrdemCompra == true) {
        OrdemCompraValueSN = "SIM"
      }
      else {
        OrdemCompraValueSN = "NÃO"
      }
      var CodigoEspecificoValueSN
      if (this.CodigoEspecifico == true) {
        CodigoEspecificoValueSN = "SIM"
      }
      else {
        CodigoEspecificoValueSN = "NÃO"
      }
      var selectedContato = ''
      if (this.TipoContato != null) {
        selectedContato = this.TipoContato.text
      }
      var novoContato =
      {
        CelularExterior: this.CelularExterior,
        ClienteSite: this.ClienteSite,
        CodigoEspecifico: this.CodigoEspecifico,
        CodigoEspecificoValue: CodigoEspecificoValueSN,
        Email: this.Email,
        Id: null,
        NomeContato: this.NomeContato,
        NomeFuncao: this.NomeFuncao,
        NumeroCelular: this.NumeroCelular,
        NumeroTelefone: this.NumeroTelefone,
        OrdemCompra: this.OrdemCompra,
        OrdemCompraValue: OrdemCompraValueSN,
        TelefoneExterior: this.TelefoneExterior,
        TempId: new Date().getTime(),
        TipoContato: selectedContato,
        TipoContatoValue: this.TipoContato.value,
        Sequencia: this.proximaSequencia,
      }

      this.proximaSequencia++;

      this.informacaocontato.push(novoContato)

      this.CelularExterior = null;
      this.ClienteSite = null;
      this.Email = null;
      this.NomeContato = null;
      this.NomeFuncao = null;
      this.NumeroCelular = null;
      this.NumeroTelefone = null;
      this.OrdemCompraSN = null;
      this.popupcontatos = false;
      this.TelefoneExterior = null;
      this.TipoContato = { text: '' };

    },
    popularDropDownTipoContato() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/TipoContato/Get',

      })
        .then((response) => {
          this.TipoContatoArray = response.data

        })
        .catch(() => {
        });
    },
    popupadicionar() {
      this.CelularExterior = '';
      this.ClienteSite = '';
      this.CodigoEspecifico = false;
      this.Email = '';
      this.NomeContato = '';
      this.NomeContato = '';
      this.NomeFuncao = '';
      this.NumeroCelular = '';
      this.NumeroTelefone = '';
      this.OrdemCompra = false;
      this.popupcontatos = true;

      this.TelefoneExterior = '';
      // this.TipoContato = '';
      this.TipoContato = { "text": "Comercial", "value": 0, "enum": 0 }
    },
    cancelarpopup() {
      this.editando = false;
      this.popupClienteAgrupador = false;
      this.popupcontatos = false;
    },
    parte1() {
      this.pt1 = true;
    },
    parte2() {
      this.pt1 = false;
    },
    cidades_exterior() {

      if (this.checkboxExt === true) {
        this.DesativaEstado = true
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getEstadoExterior',

        })
          .then((response) => {
            this.EstadoSelecionado = response.data.data.estadoId
          })
          .catch(() => {
          });
      }
      else {
        this.DesativaEstado = false
        this.EstadoSelecionado = {}
      }

    },



    cnpjExterior() {
      this.checkboxExt === false ? this.DesativaEstado = true : this.DesativaEstado = false
      this.checkboxExt === false ? this.EstadoSelecionado : this.EstadoSelecionado = null

      // this.checkboxExt === false ? this.desabilitarcep = true : this.desabilitarcep = false
      this.checkboxExt === false ? this.cnpj = '111111111000011' : this.cnpj = null
      this.checkboxExt === false ? this.desabilitado = true : this.desabilitado = false
      this.checkboxExt === false ? this.cep = '' : this.cep = ''

      this.checkboxExt === false ? this.desabilitarInscricaoEstadual = true : this.desabilitarInscricaoEstadual = false


    },
    inscricaoIsento() {
      this.inscricaoEstadual = !this.ieIsento ? 'ISENTO' : ''
    },
    adicionaTelefone() {
      if (this.inputs.length < 2) {
        this.inputs.push({
          telefone: "",
        })
      }
    },
    getlinha(data, index) {
      this.testeindex = index
      this.testedata = data
    },
    editar(data) {
      this.editando = true
      this.NomeContato = data.NomeContato;
      this.NomeFuncao = data.NomeFuncao;
      this.TipoContato = {"text": data.TipoContato, "value": data.TipoContatoValue, "enum": data.TipoContatoValue}
      this.ClienteSite = data.ClienteSite;
      this.NumeroTelefone = data.NumeroTelefone;
      this.NumeroCelular = data.NumeroCelular;
      this.Email = data.Email;
      this.OrdemCompra = data.OrdemCompra;
      this.CodigoEspecifico = data.CodigoEspecifico;
      this.TelefoneExterior = data.TelefoneExterior;
      this.CelularExterior = data.CelularExterior;
      this.sequencia = data.Sequencia;

      this.popupcontatos = true;
    },

    editarBotao() {

      if (this.NomeContato == '') {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Nome do contato é obrigatório', life: 4000 });
        return
      }


      if (!this.NumeroTelefone || !this.NumeroCelular || !this.Email || this.NumeroTelefone == ' ' || this.NumeroCelular == ' ' ) {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'É Obrigatório ter um Telefone,um celular e email', life: 4000 });
        return
      }


      if(!this.TipoContato) {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'É Obrigatório ter um Tipo de contato' , life: 4000});
        return
        }


      if (this.Email != "") {
        // eslint-disable-next-line
        let validacaoEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!this.Email.match(validacaoEmail)) {
          this.$toast.add({ severity: 'error', summary: 'Email Inválido', detail: 'Adicione um email válido', life: 4000 });
          return;
        }
      }


      var OrdemCompraValueSN
      if (this.OrdemCompra == true) {
        OrdemCompraValueSN = "SIM"
      }
      else {
        OrdemCompraValueSN = "NÃO"
      }

      var CodigoEspecificoValueSN
      if (this.CodigoEspecifico == true) {
        CodigoEspecificoValueSN = "SIM"

      }
      else {
        CodigoEspecificoValueSN = "NÃO"
      }
        this.informacaocontato[this.testeindex].NomeContato = this.NomeContato,
        this.informacaocontato[this.testeindex].NomeFuncao = this.NomeFuncao,
        this.informacaocontato[this.testeindex].TipoContato = this.TipoContato.text,
        this.informacaocontato[this.testeindex].TipoContatoValue = this.TipoContato.value,
        this.informacaocontato[this.testeindex].ClienteSite = this.ClienteSite,
        this.informacaocontato[this.testeindex].NumeroTelefone = this.NumeroTelefone,
        this.informacaocontato[this.testeindex].NumeroCelular = this.NumeroCelular,
        this.informacaocontato[this.testeindex].Email = this.Email,
        this.informacaocontato[this.testeindex].CodigoEspecificoValue = CodigoEspecificoValueSN,
        this.informacaocontato[this.testeindex].OrdemCompraValue = OrdemCompraValueSN,
        this.informacaocontato[this.testeindex].OrdemCompra = this.OrdemCompra,
        this.informacaocontato[this.testeindex].CodigoEspecifico = this.CodigoEspecifico,
        this.informacaocontato[this.testeindex].TelefoneExterior = this.TelefoneExterior,
        this.informacaocontato[this.testeindex].CelularExterior = this.CelularExterior

      this.popupcontatos = false
      this.editando = false
    },

    excluir(data) {
      this.informacaocontato.map((objeto, index) => {
        if (objeto.Sequencia === data.Sequencia) {
          this.informacaocontato.splice(index, 1)
        }
        return this.informacaocontato
      })
    },
    mostrarCampoDocumento() {
      this.campoDocumento === false ? this.campoDocumento = true : this.campoDocumento = false
    },

    fechapopup() {
      this.popupFichaCadastral = false
    },

    fechapopupICMS() {
      this.popupICMS = false
    },

    fechapopupPIS() {
      this.popupPIS = false
    },

    fechapopupIPI() {
      this.popupIPI = false
    },

    buscarEstado() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Estado/getbyestadocidade',
        data: {
          id: this.CidadeSelecionada.data

        }
      })
        .then((response) => {
          this.EstadoArray = response.data.data
        })
        .catch(() => {
        });
    },
    buscarcidade() {
      this.CidadeArray =  CidadeController.getCidadesByEstado(this.EstadoSelecionado).CidadeArray
    },
    buscarCidadeSemEstado(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.AllCity = CidadeController.getByCidadeEstado(event, this.EstadoSelecionado).CidadeArray;
        this.CidadeArray = CidadeController.getByCidadeEstado(event, this.EstadoSelecionado).CidadeArray;
      }, 1000);
    },

    popularDropDownEstado() {
      this.EstadoArray = EstadoController.getEstados().EstadosArray
    },

    
        conferecnpjAPIExiste(){
      let buscaCNPJ = ({
        cnpj: (this.cnpj.replace(/[\D]/gm, '')),
        checkboxExt: this.checkboxExt,
        flagFicha: this.flagFicha,
        RepresentanteId: this.RepresentanteId,
        UnidadeId: this.EmpresaSelecionada,
        EmpresaId: this.EmpresaSelecionada,
        sintegra: false
      });
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
        data: buscaCNPJ
      })
        .then((response) => {
          let situacao = response.data.codigoGenerico;

          if(situacao === 0 || situacao === 3 || situacao === 4){
            if(situacao === 0)
            this.mensagemDeAviso = 'Já existe cliente cadastrado com o CNPJ informado!';

            if(situacao === 3)
            this.mensagemDeAviso = 'Já existe outro cliente cadastrado com o mesmo CNPJ para outro representante!';

            if(situacao === 4)
            this.mensagemDeAviso =  'Já existe outro cliente cadastrado com a mesma base do CNPJ para outro representante!';

            this.exibeMensagemAviso = true;
            return;
          }
          let dadosCliente = response.data.data;

          if(response.data.code !== -500){
            this.$store.state.cliente = dadosCliente


          }

          this.$store.commit('salvando');
          this.situacaoVindaDoBanco = dadosCliente.clienteSituacaoSwitch

        })
    },

    gravar() {
      this.submit = true;
      let erros = this.v$.$silentErrors;
      let invalido = this.v$.$invalid;
      // if(!Tools.validaEmail(this.EmailNFE)){
      //   erros.push({
      //     '$message': 'O e-mail fornecido para a NFE não é válido'
      //   });
      //   invalido = true
      // }
      if (invalido){
        erros.forEach(erro => {
          this.$toast.add({
            severity: 'error',
            summary: 'Campo não preenchido',
            detail: erro.$message,
            life: 3000
          });
        })
      }

      else {

        if(this.$store.state.representanteSelecionadoNome == "ADMINISTRADOR"){
          this.$toast.add({ severity: 'error', summary: 'ATENÇÃO!', detail: 'Não é permitido cadastrar clientes com o representante ADMINISTRADOR', life: 4000 });

        }
        else{

        if (this.$store.state.cliente != null && [0,1].includes(this.$store.state.cliente.clienteSituacao) ){
        // SE FOR EDICAO JA SALVA DIRETO
        this.escritobotao = false
        this.largura = "35px"

        // const result = this.EmpresaSelecionada.map(x => x.id)
        // result
        let data = {
          Id: this.$store.state.cliente.id,
          cnpj: this.cnpj.replace(/[\D]/gm, ''), //mandar cnpj sem barra e risco
          razaoSocial: this.razaoSocial,
          nomeFantasia: this.nomeFantasia,
          nomeCidade: this.cidadeValue,
          EmailNFE: this.EmailNFE,
          UnidadeId: this.EmpresaSelecionada,
          ExigeOrdemCompraNaNF: this.OrdemCompraCliente,
          ExigeCodigoCompraNaNF: this.CodigoEspecificoCliente,
          RepresentanteId: this.RepresentanteId,
          numeroSuframa: this.numeroSuframa === '' ? null : Number(this.numeroSuframa),
          ZonaFranca: this.suframaSimNao == 'sim' ? true : this.suframaSimNao == '' ? null : false,
          siglaEstado: this.ufValue,
          ClienteTipoId: this.SegmentoSelecionado,
          cep: this.cep,
          telefonecelular: this.telefonecelular ? this.telefonecelular.replace(/\D/g, '') : null,
          cidadeId: this.CidadeSelecionada,
          estadoId: this.EstadoSelecionado,
          perfilMaterial: this.PerfilMaterialSelecionado,
          potencialCliente: this.PotencialSelecionado,
          inscricaoEstadual: this.inscricaoEstadual,
          icms: this.CheckIncentivoFiscal,
          ipi: this.CheckIPI,
          pisCofins: this.CheckPIS,
          contatosViewModel: this.informacaocontato.length > 0 ? this.informacaocontato : undefined,
          DescricaoObservacao: this.DescricaoObservacao,
          ClienteContato: this.informacaocontato,
          IEIsento: this.ieIsento,
          EnderecoPadrao:{
            Endereco: this.endereco,
            Cep: this.cep,
            Bairro: this.bairro,
            Complemento: this.complemento,
            EstadoId: this.EstadoSelecionado,
            CidadeId: this.CidadeSelecionada,
            TipoEndereco: 0,
          },
          ClienteAgrupador: this.nomeClienteAgrupador,
          Arquivos: this.arquivosIds,
          EmpresaAgrupador: this.EmpresaAgrupador,
        }
        this.$isLoading(true)
        this.desabilitaGravar = true
        ClienteController.cadastraClienteFichaCadastral(data).requisicao
        .then((response) => {
          this.desabilitaGravar = false

          if(response.toString().includes("Error")){
            this.$isLoading(false)
            this.resetaBotao();
            this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro de Integração. Entre em contato com o suporte.', life: 7000 });
            return
          }
          if(response.data.data)
            {
              this.ClienteId = response.data.data
              this.$toast.add({ severity: 'success', summary: 'Cliente cadastrado', detail: 'Cliente cadastrado com sucesso!', life: 4000 });
              this.limparCampos();
              this.$router.push(`/cliente-consulta`)
            }
            else{
              this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro de Integração. Entre em contato com o suporte.', life: 7000 });

            }
            this.$isLoading(false)
            this.resetaBotao();
            setTimeout(() => {
            this.MandarClienteCRM();
          }, 3000);
        })
        .finally(this.$isLoading(false))

        }
        
        else{
          // SE FOR INCLUSAO ELE VERIFICA PRIMEIRO E DPS SALVA

          let buscaCNPJ = ({
            cnpj: (this.cnpj.replace(/[\D]/gm, '')),
            checkboxExt: this.checkboxExt,
            flagFicha: this.flagFicha,
            RepresentanteId: this.RepresentanteId,
            UnidadeId: this.EmpresaSelecionada,
            EmpresaId: this.EmpresaSelecionada,
            sintegra: false
          });
    
          this.axios({
            method: 'post',
            url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
            data: buscaCNPJ
          })
            .then((response) => {
              let situacao = response.data.codigoGenerico;
    
              if(situacao === 0 || situacao === 3 || situacao === 4){
                if(situacao === 0)
                this.mensagemDeAviso = 'Já existe cliente cadastrado com o CNPJ informado!';
    
                if(situacao === 3)
                this.mensagemDeAviso = 'Já existe outro cliente cadastrado com o mesmo CNPJ para outro representante!';
    
                if(situacao === 4)
                this.mensagemDeAviso =  'Já existe outro cliente cadastrado com a mesma base do CNPJ para outro representante!';
    
                this.exibeMensagemAviso = true;
                return;
              }
    
    
            this.escritobotao = false
            this.largura = "35px"
    
            // const result = this.EmpresaSelecionada.map(x => x.id)
            // result
            let data = {
              cnpj: this.cnpj.replace(/[\D]/gm, ''), //mandar cnpj sem barra e risco
              razaoSocial: this.razaoSocial,
              nomeFantasia: this.nomeFantasia,
              nomeCidade: this.cidadeValue,
              EmailNFE: this.EmailNFE,
              UnidadeId: this.EmpresaSelecionada,
              ExigeOrdemCompraNaNF: this.OrdemCompraCliente,
              ExigeCodigoCompraNaNF: this.CodigoEspecificoCliente,
              RepresentanteId: this.RepresentanteId,
              numeroSuframa: this.numeroSuframa === '' ? null : Number(this.numeroSuframa),
              ZonaFranca: this.suframaSimNao == 'sim' ? true : this.suframaSimNao == '' ? null : false,
              siglaEstado: this.ufValue,
              ClienteTipoId: this.SegmentoSelecionado,
              cep: this.cep,
              telefonecelular: this.telefonecelular ? this.telefonecelular.replace(/\D/g, '') : null,
              cidadeId: this.CidadeSelecionada,
              estadoId: this.EstadoSelecionado,
              perfilMaterial: this.PerfilMaterialSelecionado,
              potencialCliente: this.PotencialSelecionado,
              inscricaoEstadual: this.inscricaoEstadual,
              icms: this.CheckIncentivoFiscal,
              ipi: this.CheckIPI,
              pisCofins: this.CheckPIS,
              contatosViewModel: this.informacaocontato.length > 0 ? this.informacaocontato : undefined,
              DescricaoObservacao: this.DescricaoObservacao,
              ClienteContato: this.informacaocontato,
              IEIsento: this.ieIsento,
              EnderecoPadrao:{
                Endereco: this.endereco,
                Cep: this.cep,
                Bairro: this.bairro,
                Complemento: this.complemento,
                EstadoId: this.EstadoSelecionado,
                CidadeId: this.CidadeSelecionada,
                TipoEndereco: 0,
              },
              ClienteAgrupador: this.nomeClienteAgrupador,
              Arquivos: this.arquivosIds,
              EmpresaAgrupador: this.EmpresaAgrupador,
            }
            this.$isLoading(true)
            this.desabilitaGravar = true
            ClienteController.cadastraClienteFichaCadastral(data).requisicao
            .then((response) => {
              this.desabilitaGravar = false
    
              if(response.toString().includes("Error")){
                this.$isLoading(false)
                this.resetaBotao();
                this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro de Integração. Entre em contato com o suporte.', life: 7000 });
                return
              }
              if(response.data.data)
                {
                  this.ClienteId = response.data.data
                  this.$toast.add({ severity: 'success', summary: 'Cliente cadastrado', detail: 'Cliente cadastrado com sucesso!', life: 4000 });
                  this.limparCampos();
                  this.$router.push(`/cliente-consulta`)
                }
                else{
                  this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro de Integração. Entre em contato com o suporte.', life: 7000 });
    
                }
                this.$isLoading(false)
                this.resetaBotao();
                setTimeout(() => {
                this.MandarClienteCRM();
              }, 3000);
            })
            .finally(this.$isLoading(false))
    
    
    
    
            })


        }
      }
    }
    },

    MandarClienteCRM() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/EnviarClienteCRM/${this.ClienteId}/${this.EmpresaSelecionada}`,
      })
        .then(() => {
        })
        .catch(() => {
        });
    },

    consultarCliente() {
      this.$router.push('/cliente-consulta')
    },

    resetaBotao(){
      this.escritobotao = true
      this.largura = "240px"
    },

    limparCampos(){
      this.modoEdicao = false;
      this.submit = false;
      this.cnpj = null;
      this.checkboxExt = null;
      this.ieIsento = null;
      this.codigo = null;
      this.razaoSocial = null;
      this.nomeFantasia = null;
      this.cep = '';
      this.EmailNFE = null;
      this.EstadoSelecionado = {};
      this.CidadeSelecionada = {};
      this.numeroSuframa = null;
      this.endereco = null;
      this.bairro = null;
      this.complemento = null;
      this.SegmentoSelecionado = null;
      this.PerfilMaterialSelecionado = null;
      this.PotencialSelecionado = null;
      this.inscricaoEstadual = null;
      this.CheckIncentivoFiscal = false;
      this.CheckIPI = false;
      this.CheckPIS = false;
      this.nomeContato = null;
      this.nomeFuncao = null;
      this.codigo = null;
      this.tipoContato = null;
      this.clienteSite = null;
      this.email = null;
      this.numeroTelefone = null;
      this.numeroCelular = null;
      this.codClienteAgrupador = null;
      this.nomeClienteAgrupador = null;
      this.CheckOrdemCompra = false;
      this.CheckCodEspecifico = false;
      this.observacoes = null;
      this.informacaocontato = [];
      this.CheckOrdemCompra = false;
      this.CheckCodEspecifico = false;
      this.DescricaoObservacao = null;
      this.OrdemCompraCliente = false;
      this.CodigoEspecifico = false;
      this.OrdemCompra = false;
      this.OrdemCompraCliente = false;
      this.CodigoEspecificoCliente = false;
      this.telefonecelular = '';
    },

    novoCliente() {
      this.limpar()
      this.popupFichaCadastralCliente = false
      window.location.reload()
    },
    cadastrarClienteEmDesenvolvimento() {
      this.$router.push('/cliente-em-desenvolvimento')
    },

    ClientGet() {
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API + 'Cliente/FichaCadastral/Get',
      })
        .then((response) => {
          this.nomeFantasia = response.data.data

        })
        .catch(() => {
        });
    },
    GetSegmento() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/Segmento/Get',
      })
        .then((response) => {
          this.SegmentoArray = response.data
        })
        .catch(() => {
        });
    },
    popularDropDownEmpresa() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Empresa/get',

      })
        .then((response) => {
          this.EmpresaArray = response.data.data;
          this.preencheEmpresa();
        })
        .catch(() => {
        });
    },
    popularDropDownPerfilMaterial() {
      this.PerfilMaterialArray  = ClienteDesenvolvimentoController.getPerfilMateriais().PerfilMateriais
    },
    popularDropDownPotencial() {
      this.PotencialArray = ClienteDesenvolvimentoController.getPotencial().PotencialArray
    },

    abrirPopupICMS() {
      this.popupICMS = true
    },
    abrirPopupPIS() {
      this.popupPIS = true
    },
    abrirPopupIPI() {
      this.popupIPI = true
    },
    uploadICMS(e) {

      let fileArray = e.files
      let data = new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.nomeFantasia)
      }


      this.axios({

        method: 'Post',
        data: data,
        url: process.env.VUE_APP_WEB_API + 'Arquivo/postIcms',
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then((respon) => {

          this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Arquivo ICMS enviado com sucesso!', life: 4000 });
          this.ICMSArray = respon.data.data
          // this.arquivosIds.push({
          //   ArquivoId: respon.data.data[0],
          //   Tipo: 0
          // })

          this.ICMSArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 0
            })})
        })
        .catch(() => {
          this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao enviar o Arquivo ICMS', life: 4000 });
        });

    },

    uploadPIS(e) {
      let fileArray = e.files
      let data = new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.nomeFantasia)
      }

      this.axios({
        method: 'Post',
        data: data,
        url: process.env.VUE_APP_WEB_API + 'Arquivo/postPis',
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then((respon) => {
          /*eslint-disable */


          this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Arquivo PIS/COFINS enviado com sucesso!', life: 4000 });
          this.PISArray = respon.data.data
          // this.arquivosIds.push({
          //   ArquivoId: respon.data.data[0],
          //   Tipo: 1
          // })

          this.PISArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 1
            })})



        })
        .catch(() => {
          this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao enviar o Arquivo PIS/COFINS', life: 4000 });
        });
    },

    uploadIPI(e) {

      let fileArray = e.files
      let data = new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.nomeFantasia)
      }


      this.axios({

        method: 'Post',
        data: data,
        url: process.env.VUE_APP_WEB_API + 'Arquivo/postIpi',
        headers: { 'Content-Type': 'multipart/form-data' }

      })
        .then((respon) => {
          this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Arquivo IPI enviado com sucesso!', life: 4000 });
          this.IPIArray = respon.data.data

          this.IPIArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 2
            })

        })

        })
        .catch(() => {
          this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao enviar o Arquivo IPI', life: 4000 });
        });

    },

    habilitarbotao() {
      if (this.cnpj != null
        && this.codigo != null
        && this.razaoSocial != null
        && this.nomeFantasia != null
        && this.cep != null
        && this.endereco != null
        && this.bairro != null
        && this.complemento != null
        && this.EstadoSelecionado != null
        && this.CidadeSelecionada != null
        && this.SegmentoSelecionado != null
        && this.EmpresaSelecionada != null
        && this.PerfilMaterialSelecionado != null
        && this.PotencialSelecionado != null
      ) {
        this.disabled = false
      }
    },

    limpar() {
      this.modoEdicao = false;
      this.$store.commit('limpandoCliente');
      this.submit = false;
      this.cnpj = null;
      this.checkboxExt = false;
      this.ieIsento = null;
      this.codigo = null;
      this.razaoSocial = null;
      this.nomeFantasia = null;
      this.cep = '';
      this.EstadoSelecionado = {};
      this.CidadeSelecionada = {};
      this.numeroSuframa = null;
      this.endereco = null;
      this.bairro = null;
      this.complemento = null;
      this.SegmentoSelecionado = null;
      this.PerfilMaterialSelecionado = null;
      this.PotencialSelecionado = null;
      this.inscricaoEstadual = null;
      this.CheckIncentivoFiscal = false;
      this.CheckIPI = false;
      this.CheckPIS = false;
      this.nomeContato = null;
      this.nomeFuncao = null;
      this.codigo = null;
      this.tipoContato = null;
      this.clienteSite = null;
      this.email = null;
      this.numeroTelefone = null;
      this.numeroCelular = null;
      this.codClienteAgrupador = null;
      this.nomeClienteAgrupador = null;
      this.CheckOrdemCompra = false;
      this.CheckCodEspecifico = false;
      this.observacoes = null;
      this.informacaocontato = [];
      this.informacaoClienteAgrupador = [];
      this.CheckOrdemCompra = false;
      this.CheckCodEspecifico = false;
      this.DescricaoObservacao = null;
      this.DesativaCidade = false;
      this.DesativaEstado = false;
      this.clienteId = undefined;
      this.OrdemCompraCliente = false;
      this.CodigoEspecificoCliente = false;
    },

    excluirClienteAgrupador(data) {
      this.informacaoClienteAgrupador.map((objeto, index) => {
        if (objeto.id === data.id) {
          this.informacaoClienteAgrupador.splice(index, 1)
        }
        return this.informacaoClienteAgrupador
      })
    },

    AdicionarNoGridClienteAgrupador() {
      if (!(this.nomeClienteAgrupador != null)) {
        this.$toast.add({ severity: 'error', summary: 'Nenhum Cliente selecionado', detail: 'Selecione um cliente para adicionar', life: 4000 });
        return
      }
    },

    popupadicionarClienteAgrupador() {
      this.popupClienteAgrupador = true
    },

    fechapopupSucesso() {
      this.popupFichaCadastralCliente = false

    },

    verificarAlteracaoListaEmpresa() {
      this.alteracaoLista = true
    },



    AddCidadeFicha(data){
      this.axios({
        method: 'post',
        data: data,
        url: process.env.VUE_APP_WEB_API + `Cidade/GetCidadeByNameFicha`,
      })
      .then((response) => {
        this.ehEdicao=true;
        this.CidadeSelecionada = response.data.data.id
        this.EstadoSelecionado = response.data.data.estadoId

        this.buscarcidade()

      })
      .catch(() => {
      });
    },


    async getCEP() {
      if (this.cep === "") {
      this.cidadeValue = null;
        this.ufValue = null;
        this.ValidaCEP()
      } else {
        var dados = await CepService.getCep(this.cep)
        if(dados === null)
        {
          return;
        }

        if(dados.ufSigla === undefined || dados.nomeCidade == undefined)
        {
          return;
        }

        this.cidadeValue = dados.nomeCidade;
        this.ufValue = dados.ufSigla;
        this.bairro = dados.bairro;
        this.endereco = dados.logradouro;
        this.ValidaCEP()
        let data = this.AllCity.find((Element) => Element.nomeCidade.includes(dados.nomeCidade))
        if (data !== undefined) {
          this.CidadeSelecionada = data.id
          let estado = this.EstadoArray.find((Element) => Element.siglaEstado.includes(this.ufValue))
          this.EstadoSelecionado = estado == undefined ? null : estado.id


        } else {
          let data = {
            nome: this.cidadeValue,
            siglaEstado: this.ufValue,
            bairroCidade: this.bairro
          }
          this.AddCidade(data)
      }
    }
    },
    AddCidade(data) {
      this.axios({
        method: 'post',
        data: data,
        url: process.env.VUE_APP_WEB_API + `Cidade/AddCidade`,
      })
        .then((response) => {
          this.CidadeSelecionada = response.data.data.id
          this.EstadoSelecionado = response.data.data.estadoId

          this.cidadeValue = response.data.data.id
          this.ufValue = response.data.data.estadoId
        })
        .catch(() => {
        });
    },

    ValidaCEP() {
      if (this.cep !== "") {
        this.DesativaEstado = true
        this.DesativaCidade = true
      }
      else {
        this.DesativaEstado = false
        this.DesativaCidade = false
        this.cidadeValue = null
        this.ufValue = null
      }
    },

    buscarClientes(event){
      
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(event, this.$store.state.representanteSelecionadoId, this.EmpresaAgrupador).requisicao
        .then(res => {
          
          this.ClientesArray = res.data.data
          this.nomeClienteAgrupador = this.ClientesArray.filter(objeto => objeto.codigoExterno === this.$store.state.cliente.clienteAgrupador.codigoClienteAgrupador)[0];

          this.setCodigoExternoEmpresa()
        })
      }, 1000);
    },


    exibeMensagemAvisoPopup () {
      this.exibeMensagemAviso = false
      this.cnpj = ''
    },

    popularDropDownEmpresaAgrupador() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Empresa/get',
      })
        .then((response) => {
          this.EmpresaAgrupadorArray = response.data.data;
        })
        .catch(() => {
        });
    },

  },

  computed: {
    enderecoeditgrid(){
      if(this.cidadenome === 'Manaus' || this.cidadeValue === 'Manaus'){
        if((this.suframaSimNao === 'sim' && this.cidadenome === 'Manaus') || (this.suframaSimNao === 'sim' && this.cidadeValue==='Manaus')){
          return '1 / 6 / 1 / 8' ;
        }
        return '1 / 5 / 1 / 7';
      }
      return '1 / 4 / 1 / 6';
    },
    bairroeditgrid(){
      if(this.cidadenome === 'Manaus' || this.cidadeValue === 'Manaus'){
        if((this.suframaSimNao === 'sim' && this.cidadenome === 'Manaus') || (this.suframaSimNao === 'sim' && this.cidadeValue==='Manaus')){
          return '1 / 8 / 1 / 8' ;
        }
        return '1 / 7 / 1 / 8';
      }
      return '1 / 6 / 1 / 8';
    },
  },

  watch: {
    PerfilMaterialArray(newValue) {
      if (newValue != null && newValue.length > 0) {
        if (this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacaoSwitch == 0) {
          this.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
        }
      }

    },
    PotencialArray(newValue) {
      if (newValue != null && newValue.length > 0) {
        if (this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacaoSwitch == 0) {
          this.PotencialSelecionado = this.$store.state.cliente.potencialCliente
        }
      }
    },
    EstadoSelecionado: function (newValue) {
      if (newValue !== null)
        this.buscarcidade()
    },
    // cep(){
    //   if(this.cep === ''){
    //     this.EstadoSelecionado = ''
    //     this.CidadeSelecionada = ''
    //     this.DesativaCidade = false
    //     this.DesativaEstado = false

    //     if(this.endereco !== ''){
    //       this.endereco = ''
    //       this.complemento = ''
    //       this.bairro = ''
    //     }
    //   }
    // }
  },
});
